import React from "react"
import {Redirect, Route} from "react-router-dom"

import AppContainer from "@irati/ui/src/AppContainer"
import {PartialRoute} from "@irati/utils/history/routing"
import devToggles from "@irati/dev-toggles"
import APPS from "@irati-web/app/src/routeConfig"

import benefitPage from "./benefitPage"

export const ctwURL = "cycle-to-work"
export const heURL = "home-electronics"
export const alpURL = "annual-leave-purchase"

const benefitRoutes = ({path}) => {
  if (devToggles.showPayrollPayNewFlow()) {
    return (
      <Route
        path={path}
        render={() => (
          <AppContainer>
            <Route exact path={`${APPS.BENEFITS}/${ctwURL}`} component={() => <Redirect to={APPS.CYCLETOWORK} />} />
            <Route exact path={`${APPS.BENEFITS}/${heURL}`} component={() => <Redirect to={APPS.HOMEANDELECTRONICS} />} />
            <PartialRoute match={path} exact path={`/${alpURL}`} component={benefitPage} componentProps={{benefit: "alp"}} title="Annual Leave Purchase" />
          </AppContainer>
        )}
      />
    )
  }

  return (
    <Route
      path={path}
      render={() => (
        <AppContainer>
          <PartialRoute match={path} exact path={`/${ctwURL}`} component={benefitPage} componentProps={{benefit: "ctw"}} title="Cycle to Work" />
          <PartialRoute match={path} exact path={`/${heURL}`} component={benefitPage} componentProps={{benefit: "he"}} title="Home & Electronics" />
          <PartialRoute match={path} exact path={`/${alpURL}`} component={benefitPage} componentProps={{benefit: "alp"}} title="Annual Leave Purchase" />
        </AppContainer>
      )}
    />
  )
}

export default benefitRoutes
